// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1838n","rotate":"Loader_rotate__3mMhK"};